import { Box, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { customToast, showApiResponseToast } from '../../utils/customToast'  // Add this line
import IconReusable from '../../components/IconReusable'
import { CustomButton } from '../../v2/MUI_custom_component'
import OnboardingContainer from './OnboardingContainer';
import AddressDetailModal from './Components/AddressDetailModal'
import HumbeeModal from '../../v2/MUI_custom_component/Modal/HumbeeModal'
import DataLostSvg from '../Illustrration/components/DataLostSvg'
import IllustrationWrapper from '../Illustrration/IllustrationWrapper'
import NoInventorySvg from '../Illustrration/components/NoInventorySvg'
import { firmOnboardingAction } from './API/Action'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetMeAction, getSecondaryPermissionsAction } from '../../screen/auth/action'
import { refreshTokenAction } from '../../v2/Onboarding/auth/action'
import { toast } from 'react-toastify'
import { fetchSuppliers } from '../Common/Entity/actions/reduxActions'

const ConfirmOnboardDetails = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selected_firm = useSelector((state) => state.dashboardReducer.selected_firm);
    const { 
        selected_manufacturer_roles,
        gst_flow,
        gst_details,
        pan_details,
        operational_details,
        existingFirm
    } = useSelector(state => state.FirmOnboardingReducer || {});
    
    const location = useLocation();
    const manu_role = location.state?.manu_role || null;
    const [showDetailModal, setShowDetailModal] = useState(!manu_role);
    const [loading, setLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});


    const onEdit = () => {
        setShowDetailModal(true);
    }
    const handleDeleteClick = (manufacturer) => {
        if (!manufacturer?.manufacturer_id) return;
        // setSelectedManufacturerToDelete(manufacturer);
        dispatch({ 
            type: 'REMOVE_MANUFACTURER_ROLE', 
            payload: manufacturer.manufacturer_id 
        });
        const remainingRoles = selected_manufacturer_roles.filter(
            role => role.manufacturer_id !== manufacturer.manufacturer_id
        );
        const hasGstRequired = remainingRoles.some(role => role.is_gst_required);
        dispatch({ type: 'SET_SHOW_GST_INPUT', payload: hasGstRequired });
    }
    const validateAddressDetails = () => {
        const addressData = operational_details;
        const errors = {};

        if (!addressData) {
            errors.address_line_1 = 'Address Line 1 is required';
            errors.state_id = 'State is required';
            errors.district_id = 'District is required';
            errors.location_id = 'City is required';
            errors.pincode_id = 'Pincode is required';
            setFieldErrors(errors);
            return { isValid: false, errors };
        }

        if (!addressData.firm_name?.trim()) {
            errors.firm_name = 'Firm Name is required';
        }

        if (!addressData.address_line_1?.trim()) {
            errors.address_line_1 = 'Address Line 1 is required';
        }

        if (!addressData.state_id) {
            errors.state_id = 'State is required';
        }

        if (!addressData.district_id) {
            errors.district_id = 'District is required';
        }

        if (!addressData.location_id) {
            errors.location_id = 'City is required';
        }

        if (!addressData.pincode_id) {
            errors.pincode_id = 'Pincode is required';
        }

        setFieldErrors(errors);

        if (Object.keys(errors).length > 0) {
            return { isValid: false, errors };
        }
        return { isValid: true, errors: {} };
    }
    useEffect(() => {
        validateAddressDetails();
    }, [operational_details]);
    const handleContinue = async() => {
        const { isValid, errors } = validateAddressDetails();
        if (!isValid) {
            setShowDetailModal(true);
            return;
        }
        const registeredAddress = gst_flow ? gst_details : pan_details;
        const payload = {
            company_name: operational_details?.firm_name,
            company_gstin: gst_details?.gst_number || null,
            pancard_no: operational_details?.pan_number || null,
            registered_address: {
                company_address: {
                    address_line_1: registeredAddress?.address_line_1 || operational_details?.address_line_1,
                    address_line_2: registeredAddress?.address_line_2 || operational_details?.address_line_1,
                },
                location_id: registeredAddress?.location_id || operational_details?.location_id ,
                state_id: registeredAddress?.state_id || operational_details?.state_id,
                district_id: registeredAddress?.district_id || operational_details?.district_id,
                pincode: registeredAddress?.pincode_id || operational_details?.pincode_id,
            },
            operational_address: {
                company_address: {
                    address_line_1: operational_details?.address_line_1 || null,
                    address_line_2: operational_details?.address_line_2 || null,
                },
                location_id: operational_details?.location_id || null,
                state_id: operational_details?.state_id || null,
                district_id: operational_details?.district_id || null,
                pincode: operational_details?.pincode_id || null,
            },
            role_details: selected_manufacturer_roles?.map(role => ({
                manufacturer_id: role.manufacturer_id,
                role_id: role.role_id
            })),
            existing_company_id: selected_firm && existingFirm ? selected_firm : null,
        };
        setLoading(true);
        const { data, error, message } = await firmOnboardingAction(payload);
        setLoading(false);
        if (!error) {
            if(data && data.response_meta){
                showApiResponseToast(data.response_meta, message, {
                    CustomButton,
                    toast,
                    navigate,
                    path: '/my-account/firm-details',
                    label: "View"
                });
            }
            const { error: userError, data: loggedInUser } = await GetMeAction();
            const { error: tokenError, data: tokenData } = await refreshTokenAction();
            const { data: secPermissionData } = await getSecondaryPermissionsAction();
            if (!userError && loggedInUser) {
            if (tokenData) {
                    localStorage.setItem('token', tokenData);
                    dispatch({ type: 'SET_USER', data: loggedInUser });
                    dispatch({
                        type: 'SET_SECONDARY_PERMISSION',
                        data: secPermissionData,
                    });
                    dispatch({
                        type: 'SET_SECONDARY_PERMISSION_ROLES',
                        data: secPermissionData.map((item) => item.role_name),
                    });
                }
            }
            dispatch({ type: 'SELECTED_FIRM', payload: data.company_id });
            data.company_id && dispatch(fetchSuppliers());
            navigate('/');
        } else {
            customToast.error(message);
        }
    }
    return (
        <OnboardingContainer 
            title="Confirmation" 
            ShowIcon={true}
            navigation={() => navigate(-1)}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
            <Box sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="labelD">
                        Business Information
                    </Typography>
                    <Box onClick={onEdit}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            cursor: 'pointer',
                            width: '24px',
                            height: '24px',
                            justifyContent: 'center',
                        }}>
                        <IconReusable name='Edit' color='#333333' size={isMobile ? 16 : 24} /> 
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
                    <Typography variant="labelD" sx={{ color:'#666666', minWidth: '160px' }}>
                        {gst_flow ? 'GST' : 'PAN'}
                    </Typography>
                    <Typography variant="body1" sx={{ color: !gst_flow && fieldErrors.pan_number ? '#D32F2F' : 'inherit' }}>
                        {gst_flow ? gst_details?.gst_number : pan_details?.pan_number }
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
                    <Typography variant="labelD" sx={{ color:'#666666', minWidth: '160px' }}>
                        Firm Name
                    </Typography>
                    <Typography variant="body1">
                        { gst_flow ? gst_details?.firm_name : pan_details?.firm_name }
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', py: 1 }}>
                    <Typography variant="labelD" sx={{ color:'#666666', minWidth: '160px' }}>
                        Address
                    </Typography>
                    <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
                        {operational_details && [
                            operational_details?.address_line_1,
                            operational_details?.address_line_2,
                            operational_details?.district_name,
                            operational_details?.location_name,
                            operational_details?.state_name,
                            operational_details?.pincode_id
                        ].filter(Boolean).join(', ')}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{
                background: '#fff',
                borderRadius: 2,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="labelD">
                        Manufacturers & Roles
                    </Typography>
                </Box>
                {selected_manufacturer_roles && selected_manufacturer_roles.length > 0 ? (
                    selected_manufacturer_roles.map((role, index) => (
                        <Box key={`${role.manufacturer_id}-${index}`} sx={{ 
                            display: 'flex', 
                            alignItems: 'flex-start', 
                            gap: { xs: 1, md: 2 },
                        }}>
                            <Box
                                sx={{
                                    width: {xs: 32, md: 64},
                                    height: {xs: 32, md: 64},
                                    borderRadius: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #D9D9D9',
                                }}
                            >
                                <Box
                                    component="img"
                                    src={role.manufacturer_logo}
                                    alt={role.manufacturer_name}
                                    sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </Box>
                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', gap: { xs: 1, md: 2 } }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.5, md: 1 } }}>
                                    <Box>
                                        <Typography variant="bodyL">
                                            {role.manufacturer_name}
                                        </Typography>
                                        <Typography variant="body1" sx={{ color: '#666666' }}>
                                            {role.role_name}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Box 
                                onClick={() => handleDeleteClick(role)}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    cursor: 'pointer',
                                    width: '24px',
                                    height: '24px',
                                    justifyContent: 'center',
                                }}>
                                <IconReusable name='Delete' color='#333333' size={isMobile ? 16 : 24} /> 
                            </Box>
                        </Box>
                    ))
                ) : (
                    <Box>
                        <IllustrationWrapper
                            titleVariant="h3"
                            subtitleVariant="body1"
                            subtitleStyle = {{color:'#666'}}
                            illustration={<NoInventorySvg />}
                            illustrationProps={{
                                width: 160,
                                height: 132,
                            }}
                        />
                    </Box>
                )}
                <CustomButton
                    label={selected_manufacturer_roles.length > 0 ? "Edit or Add Manufacturer" : "Add Manufacturer"}
                    variant="text"
                    fullWidth
                    onClick={
                        ()=>navigate('/firm-onboarding/select-manufacturer')
                    }
                />
            </Box>
            <CustomButton
                label="I confirm, let’s proceed!"
                variant="filled"
                fullWidth
                // disabled={selected_manufacturer_roles.length === 0}
                onClick={handleContinue}
                loading={loading}
            />
            <CustomButton
                label="Cancel"
                variant="text"
                fullWidth
                onClick={() => setShowCancelModal(true)}
            />
            <AddressDetailModal
                open={showDetailModal}
                onClose={() => setShowDetailModal(false)}
                initialValidationErrors={fieldErrors}
                firmDetails={{ operational_details, gst_details, pan_details, gst_flow }}
            />
            <HumbeeModal
                open={showCancelModal}
                onClose={()=> setShowCancelModal(false)}
                onConfirm={() => navigate('/')}
                title="Are you sure you want to cancel?"
                subtitle={`All data would be lost.`}
                confirmLabel="Yes"
                cancelLabel="No"
                illustration={<DataLostSvg />}
                width={{ xs: 400 , md:  600 }}
            />
            </Box>
        </OnboardingContainer>
    )
}

export default ConfirmOnboardDetails